// router.jsx
import { Suspense, useMemo, lazy } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { createBrowserRouter, Navigate, Outlet, RouterProvider } from 'react-router-dom';
import ProtectedRoute from 'utils/ProtectedRoute';
import AppLoader from 'app/shared/AppLoader';
import MasterLayout from 'layout/MasterLayout';
import ChargeTracker from 'app/modules/EVDashboard/pages/ChargeTracker';
import TripReport from 'app/modules/EVDashboard/pages/TripReport';
import TripInsight from 'app/modules/EVDashboard/pages/TripInsight';

const LoadingSpinner = () => (
	<div className="flex size-full items-center justify-center">
		<AppLoader />
	</div>
);

const ErrorFallback = () => (
	<div role="alert">
		<h2>Ooops, something went wrong :( </h2>
		<button onClick={() => window.location.assign(window.location.origin)}>Refresh</button>
	</div>
);

export const createAppRouter = () => {
	return createBrowserRouter([
		{ path: '/', element: <Navigate to="/evdashboard" replace /> },

		{
			path: '/evdashboard',
			element: (
				<ProtectedRoute>
					<Suspense fallback={<LoadingSpinner />}>
						<ErrorBoundary key={location.pathname} fallback={<ErrorFallback />}>
							<MasterLayout />
						</ErrorBoundary>
					</Suspense>
				</ProtectedRoute>
			),
			children: [
				{ index: true, element: <Navigate to="chargetracker" replace /> },
				{ path: 'chargetracker', element: <ChargeTracker /> },
				{ path: 'tripreport', element: <TripReport /> },
				{ path: 'tripinsight', element: <TripInsight /> },
			],
		},
		{
			path: '*',
			element: (
				<Suspense fallback={<LoadingSpinner />}>
					<ErrorFallback />
				</Suspense>
			),
		},
	]);
};

export const AppRouter = () => {
	const router = useMemo(() => createAppRouter(), []);
	return <RouterProvider router={router} />;
};
